import { render, staticRenderFns } from "./IncomingDialog.vue?vue&type=template&id=23b224c0&"
import script from "./IncomingDialog.vue?vue&type=script&lang=js&"
export * from "./IncomingDialog.vue?vue&type=script&lang=js&"
import style0 from "./IncomingDialog.vue?vue&type=style&index=0&id=23b224c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports